const FooterLinkIdentifiers = {
    REPORT_ABOUT_THIS_REPORT: 'about_report',
    REPORT_VALIDITY: 'report_validity',
    REPORT_DISCLAIMER: 'report_disclaimer'
};

export default FooterLinkIdentifiers;
